'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _history = require('history');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _reactIntlRedux = require('react-intl-redux');

var _en = require('react-intl/locale-data/en');

var _en2 = _interopRequireDefault(_en);

var _de = require('react-intl/locale-data/de');

var _de2 = _interopRequireDefault(_de);

var _fr = require('react-intl/locale-data/fr');

var _fr2 = _interopRequireDefault(_fr);

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _configureLanguage2 = require('./configureLanguage');

var _routes = require('routes');

var _routes2 = _interopRequireDefault(_routes);

var _reducers = require('reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _sagas = require('sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _IntlSafariPolyfill = require('utils/IntlSafariPolyfill');

var _IntlSafariPolyfill2 = _interopRequireDefault(_IntlSafariPolyfill);

var _authTokenActions = require('actions/authTokenActions');

require('react-select/scss/default.scss');

var _messages = require('utils/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { browserHistory } from 'react-router'
require('theme/main.scss');

// Setup react-intl localeData for English, German, French
(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray3.default)(_en2.default), (0, _toConsumableArray3.default)(_de2.default), (0, _toConsumableArray3.default)(_fr2.default)));

// Use browser history in dev, hash history in prod
var hashHistory = (0, _reactRouter.useRouterHistory)(_history.createHashHistory)();
// const history = __DEVELOPMENT__ ? browserHistory : hashHistory
var history = hashHistory;

var routingMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
var sagaMiddleware = (0, _reduxSaga2.default)();

// Grab data attributes from bootstrap DOM element
var domNode = document.getElementById('goodtogo');
// We always require this data attribute for booking id
var bookingId = domNode && domNode.getAttribute('data-booking-id');

if (domNode && bookingId) {
    // In a "trust" scenario, only an auth token needs to be provided along with booking id
    var authToken = domNode.getAttribute('data-auth-token');
    // Otherwise we require customer id and name and prompt the user for verification data to
    // request an auth token from the API
    var customerId = domNode.getAttribute('data-customer-id');
    var customerName = domNode.getAttribute('data-customer-name');
    var bootLang = domNode.getAttribute('data-lang');
    var mobileAppLink = domNode.getAttribute('data-mobile-app');
    // If an apiClientKey attribute is present,  we use that to make the initial request
    // to generate the OAuth Token
    var apiClientKey = domNode.getAttribute('data-api-client-key');

    // Initialize store with initial state and middlewares
    var store = (0, _redux.createStore)(_reducers2.default,
    // initialState for react-intl-redux's reducer set to English
    {
        booking: {
            id: bookingId,
            linkedBookingsCustomers: {}
        },
        user: {
            customerId: customerId,
            customerName: customerName,
            mobileAppLink: mobileAppLink,
            apiClientKey: apiClientKey
        },
        intl: {
            defaultLocale: 'en',
            locale: 'en',
            messages: _messages.allMessages.en
        }
    }, (0, _redux.compose)((0, _redux.applyMiddleware)(routingMiddleware), (0, _redux.applyMiddleware)(sagaMiddleware),
    // return identity function if devToolsExtension is not present (or else errors out)
    window.devToolsExtension ? window.devToolsExtension() : function (f) {
        return f;
    }));
    sagaMiddleware.run(_sagas2.default);

    // Dispatch action if authentication token was provided
    if (authToken) {
        store.dispatch((0, _authTokenActions.authTokenProvided)(authToken));
    }

    var _configureLanguage = (0, _configureLanguage2.configureLanguage)(bookingId, bootLang),
        userLocale = _configureLanguage.userLocale;

    store.dispatch((0, _reactIntlRedux.updateIntl)({
        locale: userLocale,
        messages: _messages.allMessages[userLocale]
    }));

    // Configure Raven for error reporting & add context
    if (!__DEVELOPMENT__) {
        _ravenJs2.default.config('https://e235bcabdc0345909873ca06e62202e0@sentry.io/126322', {
            release: versionNumber
        }).install();

        _ravenJs2.default.setUserContext({
            id: bookingId,
            customerId: customerId || 'agent/staff',
            customerName: customerName,
            tokenProvided: authToken
        });
    }

    // Create an enhanced history that syncs navigation events with the store
    var enhancedHistory = (0, _reactRouterRedux.syncHistoryWithStore)(history, store);

    var renderApp = function renderApp() {
        (0, _reactDom.render)(_react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(
                _reactIntlRedux.IntlProvider,
                null,
                _react2.default.createElement(_reactRouter.Router, { history: enhancedHistory, routes: _routes2.default })
            )
        ), document.getElementById('goodtogo'));
    };

    (0, _IntlSafariPolyfill2.default)(renderApp); // renders app after polyfilling Intl needed for react-intl
} else {
    if (!domNode) {
        console.error('Could not find DOM element with id "goodtogo"');
    }
    if (!bookingId) {
        console.error('Could not find `data-booking-id` attribute on "goodtogo" DOM element');
    }
}


//////////////////
// WEBPACK FOOTER
// ./app/index.js
// module id = 1361
// module chunks = 0